import { Box, Button, Typography, styled } from '@mui/material';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { DeliveryBoardItem } from 'views/delivery-board/types/delivery-board-model.type';
import ColumnsContainer from './column-container';

type Props = {
  loadingItems?: DeliveryBoardItem[];
  onRouteItems?: DeliveryBoardItem[];
  deliveredItems?: DeliveryBoardItem[];
  activeTabNumber?: (tab: number) => void;
};

const TabButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(2, 4),
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  borderTopLeftRadius: theme.spacing(4),
  borderTopRightRadius: theme.spacing(4),
  color: theme.palette.common.white,
  borderBottom: 'solid white 1px',
  background: 'transparent',
  '&:hover, &:active, &:focus ': {
    background: '#ffffff16',
    color: theme.palette.common.white,
  },
}));

const DeliveryColumnsSubTabs: React.FC<Props> = ({ loadingItems, onRouteItems, deliveredItems, activeTabNumber }) => {
  const PAGE_NAME_ID = 'deliveryBoard.columns';
  const [activeTab, setActiveTab] = useState(2);

  const handleTabChange = (tabNumber: number) => {
    activeTabNumber?.(tabNumber);
    setActiveTab(tabNumber);
  };

  const activeBackground = (id: number) => (activeTab === id ? '#ffffff16' : '');

  return (
    <>
      <Box justifyContent={'center'} display={'flex'} maxHeight={'60vh'}>
        <TabButton fullWidth onClick={() => handleTabChange(1)} sx={{ background: activeBackground(1) }}>
          <FormattedMessage id={`${PAGE_NAME_ID}.loading`} />
          <Typography ml={1}>{activeTab === 1 ? `(${loadingItems?.length})` : ''}</Typography>
        </TabButton>
        <TabButton fullWidth onClick={() => handleTabChange(2)} sx={{ background: activeBackground(2) }}>
          <FormattedMessage id={`${PAGE_NAME_ID}.onRoute`} />
          <Typography ml={1}>{activeTab === 2 ? `(${onRouteItems?.length})` : ''}</Typography>
        </TabButton>
        <TabButton fullWidth onClick={() => handleTabChange(3)} sx={{ background: activeBackground(3) }}>
          <FormattedMessage id={`${PAGE_NAME_ID}.delivered`} />
          <Typography ml={1}>{activeTab === 3 ? `(${deliveredItems?.length})` : ''}</Typography>
        </TabButton>
      </Box>

      <Box>
        {activeTab === 1 && <ColumnsContainer width={'440px'} minWidth={'100%'} data={loadingItems} />}
        {activeTab === 2 && <ColumnsContainer width={'440px'} minWidth={'100%'} data={onRouteItems} />}
        {activeTab === 3 && <ColumnsContainer width={'440px'} minWidth={'100%'} data={deliveredItems} />}
      </Box>
    </>
  );
};

export default React.memo(DeliveryColumnsSubTabs);
